import React, { useEffect, useState } from 'react';
import { Loading } from 'components/loading/Loading';
import { UsersSubscriptions } from 'pages/users-subscriptions';
import { fetchUsersSubscriptions } from 'services';
import { getPageLimit, showError } from 'utils';
import styles from './index.module.scss';

const UserSubscriptions = props => {
  const [loading, setLoading] = useState<boolean>(true);
  const [subscriptions, setSubscriptions] = useState<Record<string, any>>({});
  const { userId } = props;

  const fetchUsersSubscriptionsFn = async () => {
    try {
      const response = await fetchUsersSubscriptions({
        limit: getPageLimit(),
        filter: {
          userId,
        },
      });
      setSubscriptions(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchUsersSubscriptionsFn();
  }, []);

  if (loading) return (
    <div className={styles['loader-container']}>
      <Loading type={'mini'} />
    </div>
  );

  return (
    <div>
      <UsersSubscriptions
        {...props}
        data={subscriptions.items}
        total={subscriptions.total}
      />
    </div>
  );
};

export default UserSubscriptions;